import { IDuration } from '../../../../../../../reducers/v2';

export const getActiveDurationIdx = (durations: IDuration[], activeDurationDays: number): number | undefined => {
  const activeDuration = durations.find(({ durationInDays }) => durationInDays === activeDurationDays);

  if (!activeDuration) {
    return undefined;
  }

  return durations.indexOf(activeDuration);
};
